import React, { useEffect, useState } from 'react'
import Custombanner from '../../../../assets/img/custom-banner/bg-banner.png';
import icon1 from '../../../../assets/img/custom-banner/icon1.png';
import icon2 from '../../../../assets/img/custom-banner/icon2.png';
import icon3 from '../../../../assets/img/custom-banner/icon3.png';
import icon4 from '../../../../assets/img/custom-banner/icon4.png';
import Time from '../../../../assets/img/custom-banner/time.png';
import Language from '../../../../assets/img/custom-banner/language.png';
import Calendar from '../../../../assets/img/custom-banner/calendar.png';
import UserGroup from '../../../../assets/img/custom-banner/user-group.png';
import { send_Tour_Request } from '../../../../api/global/Global';
import { User_Authentication } from '../../../../user_authentication/User_Authentication';
import { IMG_BASE_URL } from '../../../../config/Config';
import { toast } from 'react-toastify';
import { isValidEmail, isAlphabetical } from '../../../validation/Validation';

const Custom_Banner = ({ tourData }) => {
    const [minTime, setMinTime] = useState("");

    const [showModal, setShowModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [modalForm, setModalForm] = useState({
        name: '',
        email: '',
        phone: '',
        language: "",
        location: '',
        country_code: '+91',// Default country code
        date: '',
        time: ''
    });

    // Handle modal form input changes
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    const handleModalInputChange = (e) => {
        const { name, value } = e.target;

        setErrorMessage("")
        if (name === "phone" && value.length > 10) {
            return
        }

        if (name === "name" && value && !isAlphabetical(value)) {
            setErrorMessage("Name should only contain alphabetic characters");
            return;
        }

        if (name === "email") {
            if (!emailRegex.test(value)) {
                setErrorMessage("Please enter a valid email address");
            } else {
                setErrorMessage("");
            }
        }

        const now = new Date();
        setMinTime(now.toTimeString().slice(0, 5));

        if (name === "time" && value < minTime) {
            setErrorMessage("Please choose a valid future time.");
            return;
        }
        setModalForm(prev => ({
            ...prev,
            [name]: value
        }));
    };


    // Reset messages
    const resetMessages = () => {
        setSuccessMessage('');
        setErrorMessage('');
    };
    // Handle Write to Us button click
    const handleWriteToUs = () => {
        setShowModal(true);
        resetMessages();
    };

    const handleSubmit_Tour = async (e) => {
        e.preventDefault();
        resetMessages();

        if (!modalForm?.email || !isValidEmail(modalForm?.email)) {
            toast("Please enter a valid email address.");
            return;
        }

        try {

            const token = User_Authentication();
            // if (!token) {
            //     // setIsLoading(false);
            //     throw new Error("User token not found");
            // }
            const response = await send_Tour_Request(modalForm, {
                headers: {
                    content: "application/json",
                    // Authorization: `Bearer ${token}`,
                }
            });
            if (response?.data?.status == 200) {
                setSuccessMessage(response?.data?.message);
                setModalForm({
                    name: '',
                    email: '',
                    phone: '',
                    language: "",
                    location: '',
                    date: '',
                    time: ''
                });
                setTimeout(() => {
                    setShowModal(false);
                }, 3000);
            }
            else if (response?.response?.data?.status == 401) {
                setErrorMessage(response?.response?.data?.message);
            } else {
                setErrorMessage('Something went wrong. Please try again later.');
            }
        } catch (error) {
            setErrorMessage(error?.message);
            console.error("Error submitting form:", error);
        }
    };

    useEffect(() => {
        const now = new Date();
        setMinTime(now.toTimeString().slice(0, 5));
    }, [showModal]);

    const closemodal = () => {
        setShowModal(false)
        setModalForm({
            name: '',
            email: '',
            phone: '',
            language: "",
            location: '',
            date: '',
            time: ''
        });
    }
    return (
        <section id="custom-tour-banner" className="relative overflow-hidden !bg-no-repeat !bg-center !bg-cover py-12 md:py-20 lg:py-24" style={{
            background: `url(${IMG_BASE_URL}${tourData?.banner_image})`,
        }}>
            {/* Dark gradient overlay for text readability and cinematic look */}
            <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/75 to-black/40 lg:from-black/90 lg:via-black/80 lg:to-black/30 z-0"></div>

            <div className="container mx-auto px-4 md:px-8 lg:px-12 relative z-10">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-stretch w-full">
                    {/* Left Column: Title & Feature Grid */}
                    <div className="flex flex-col justify-center text-left space-y-6 lg:col-span-2">
                        <div>
                            <h2 className="bodonibook_font text-3xl md:text-4xl lg:text-5xl text-white font-bold capitalize leading-tight tracking-wide">
                                {tourData?.title}
                            </h2>
                            <div className="h-[2px] w-20 bg-gradient-to-r from-[#FFB500] to-transparent mt-3 mb-4"></div>
                            <p className="text-base md:text-lg font-medium text-gray-200 capitalize max-w-2xl leading-relaxed">
                                {tourData?.sub_title}
                            </p>
                        </div>

                        {/* Feature Cards Grid */}
                        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-6 text-white">
                            {[
                                { img: tourData?.image_1, title: tourData?.title_1 },
                                { img: tourData?.image_2, title: tourData?.title_2 },
                                { img: tourData?.image_3, title: tourData?.title_3 },
                                { img: tourData?.image_4, title: tourData?.title_4 }
                            ].filter(item => item.img || item.title).map((item, idx) => (
                                <div key={idx} className="flex flex-col items-center text-center p-4 bg-white/10 backdrop-blur-md border border-white/15 rounded-xl hover:bg-white/20 hover:border-white/30 transition-all duration-300 hover:-translate-y-1 group shadow-lg">
                                    <div className="w-16 h-16 rounded-full bg-white/10 flex items-center justify-center mb-3 group-hover:scale-110 transition-transform duration-300 shadow-inner">
                                        <img src={`${IMG_BASE_URL}${item.img}`} alt={item.title || "Feature"} className="w-10 h-10 object-contain" />
                                    </div>
                                    <span className="text-xs md:text-sm font-semibold tracking-wide uppercase text-gray-100">{item.title}</span>
                                </div>
                            ))}
                        </div>

                        {/* Trigger Button */}
                        <div className="pt-4">
                            <button
                                id="btn-book-tour-trigger"
                                type="button"
                                onClick={handleWriteToUs}
                                className="relative overflow-hidden group text-white font-bold px-8 py-4 bg-gradient-to-r from-[#9F2225] to-[#FFB500] rounded-full shadow-lg shadow-red-950/40 hover:shadow-xl hover:shadow-yellow-500/20 transform hover:-translate-y-0.5 active:translate-y-0 transition-all duration-200 tracking-wide uppercase text-xs md:text-sm"
                            >
                                <span className="relative z-10 flex items-center gap-2">
                                    Book Your Tour Now
                                    <svg className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                                    </svg>
                                </span>
                                <div className="absolute inset-0 bg-gradient-to-r from-[#FFB500] to-[#9F2225] opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-full z-0"></div>
                            </button>
                        </div>
                    </div>

                    {/* Right Column: Tour Details Pane */}
                    <div className="lg:col-span-1 w-full flex">
                        <div className="p-6 md:p-8 lg:p-10 tour_info relative flex flex-col justify-center w-full">
                            <div className="relative z-10 tour_infotwo space-y-6">
                                <div>
                                    <h3 className="bodonibook_font text-2xl lg:text-3xl text-white font-bold capitalize tracking-wide">
                                        {tourData?.information || "Tour Details"}
                                    </h3>
                                    <div className="h-[2px] w-12 bg-[#FFB500] mt-2"></div>
                                </div>

                                <ul className="space-y-4">
                                    {[
                                        { icon: Time, label: "Duration", val: tourData?.duration },
                                        { icon: Language, label: "Language", val: tourData?.language },
                                        { icon: Calendar, label: "Schedule", val: tourData?.days },
                                        { icon: UserGroup, label: "Group Size", val: tourData?.group_size }
                                    ].filter(item => item.val).map((item, idx) => (
                                        <li key={idx} className="text-sm font-medium text-gray-100 flex gap-4 items-center bg-black/15 hover:bg-black/25 p-3 rounded-lg border border-white/5 transition-colors duration-200">
                                            <div className="w-8 h-8 rounded-lg bg-[#FFB500]/15 flex items-center justify-center shrink-0">
                                                <img src={item.icon} alt="" className="w-4 h-4 object-contain" />
                                            </div>
                                            <div>
                                                <span className="text-[10px] text-gray-300 block uppercase tracking-wider font-semibold">{item.label}</span>
                                                <span className="text-sm font-semibold text-white">{item.val}</span>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* Booking Modal (Responsive & Scrollable Backdrop) */}
            <div className={`fixed inset-0 z-50 overflow-y-auto bg-gray-950/85 backdrop-blur-sm p-4 transition-all duration-300 flex items-center justify-center ${!showModal ? 'hidden opacity-0 pointer-events-none' : 'block opacity-100'}`}>
                <div className="w-full max-w-lg mx-auto bg-white rounded-2xl shadow-2xl relative overflow-hidden my-8 transform transition-transform duration-300 scale-100">
                    {/* Modal Header */}
                    <div className="bg-gradient-to-r from-[#9F2225] to-[#723F25] px-6 py-5 text-white relative">
                        <h3 className="bodonibook_font text-xl md:text-2xl font-bold tracking-wide">
                            Book Your Tour
                        </h3>
                        <p className="text-xs text-gray-200 mt-1">Step Inside the World of Timeless Craftsmanship</p>
                        <button
                            id="btn-close-tour-modal"
                            type="button"
                            onClick={closemodal}
                            className="absolute top-4 right-4 text-white/80 hover:text-white bg-white/10 hover:bg-white/20 p-1.5 rounded-full transition-colors duration-200 focus:outline-none"
                            aria-label="Close modal"
                        >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                            </svg>
                        </button>
                    </div>

                    {/* Modal Form Body */}
                    <div className="p-6">
                        <form id="tour-booking-form" onSubmit={handleSubmit_Tour} className="space-y-4">
                            {/* User Name */}
                            <div>
                                <label htmlFor="input-booking-name" className="text-gray-700 font-semibold text-xs block mb-1">User Name</label>
                                <input
                                    id="input-booking-name"
                                    type="text"
                                    placeholder="Enter your name"
                                    name="name"
                                    value={modalForm.name}
                                    onChange={handleModalInputChange}
                                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-xs md:text-sm text-gray-700 bg-gray-50 focus:bg-white focus:border-[#9F2225] focus:ring-2 focus:ring-[#9F2225]/15 transition-all duration-200 outline-none h-10"
                                    required
                                />
                            </div>

                            {/* Email ID */}
                            <div>
                                <label htmlFor="input-booking-email" className="text-gray-700 font-semibold text-xs block mb-1">Email ID</label>
                                <input
                                    id="input-booking-email"
                                    type="email"
                                    name="email"
                                    placeholder="Enter your e-mail here"
                                    value={modalForm.email}
                                    onChange={handleModalInputChange}
                                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-xs md:text-sm text-gray-700 bg-gray-50 focus:bg-white focus:border-[#9F2225] focus:ring-2 focus:ring-[#9F2225]/15 transition-all duration-200 outline-none h-10"
                                    required
                                />
                            </div>

                            {/* Phone Number */}
                            <div>
                                <label htmlFor="input-booking-phone" className="text-gray-700 font-semibold text-xs block mb-1">Phone Number</label>
                                <input
                                    id="input-booking-phone"
                                    type="number"
                                    name="phone"
                                    placeholder="Enter your phone number"
                                    value={modalForm.phone}
                                    onChange={handleModalInputChange}
                                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-xs md:text-sm text-gray-700 bg-gray-50 focus:bg-white focus:border-[#9F2225] focus:ring-2 focus:ring-[#9F2225]/15 transition-all duration-200 outline-none h-10"
                                    required
                                />
                            </div>

                            {/* Language & Location (Two Columns on Desktop) */}
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <div>
                                    <label htmlFor="input-booking-language" className="text-gray-700 font-semibold text-xs block mb-1">Language</label>
                                    <input
                                        id="input-booking-language"
                                        type="text"
                                        placeholder="e.g. English"
                                        name="language"
                                        value={modalForm.language}
                                        onChange={handleModalInputChange}
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-xs md:text-sm text-gray-700 bg-gray-50 focus:bg-white focus:border-[#9F2225] focus:ring-2 focus:ring-[#9F2225]/15 transition-all duration-200 outline-none h-10"
                                        required
                                    />
                                </div>
                                <div>
                                    <label htmlFor="input-booking-location" className="text-gray-700 font-semibold text-xs block mb-1">Location</label>
                                    <input
                                        id="input-booking-location"
                                        type="text"
                                        placeholder="Enter your location"
                                        name="location"
                                        value={modalForm.location}
                                        onChange={handleModalInputChange}
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-xs md:text-sm text-gray-700 bg-gray-50 focus:bg-white focus:border-[#9F2225] focus:ring-2 focus:ring-[#9F2225]/15 transition-all duration-200 outline-none h-10"
                                        required
                                    />
                                </div>
                            </div>

                            {/* Date & Time (Two Columns) */}
                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <label htmlFor="input-booking-date" className="text-gray-700 font-semibold text-xs block mb-1">Date</label>
                                    <input
                                        id="input-booking-date"
                                        type="date"
                                        name="date"
                                        value={modalForm.date}
                                        min={new Date().toISOString().split("T")[0]}
                                        onChange={handleModalInputChange}
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-xs md:text-sm text-gray-700 bg-gray-50 focus:bg-white focus:border-[#9F2225] focus:ring-2 focus:ring-[#9F2225]/15 transition-all duration-200 outline-none h-10"
                                        required
                                    />
                                </div>
                                <div>
                                    <label htmlFor="input-booking-time" className="text-gray-700 font-semibold text-xs block mb-1">Time</label>
                                    <input
                                        id="input-booking-time"
                                        type="time"
                                        name="time"
                                        value={modalForm.time}
                                        min={minTime}
                                        onChange={handleModalInputChange}
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-xs md:text-sm text-gray-700 bg-gray-50 focus:bg-white focus:border-[#9F2225] focus:ring-2 focus:ring-[#9F2225]/15 transition-all duration-200 outline-none h-10"
                                        required
                                    />
                                </div>
                            </div>

                            {/* Validation Message Boxes */}
                            {successMessage && (
                                <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg text-xs flex items-center gap-2">
                                    <svg className="w-4 h-4 text-green-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                    </svg>
                                    <span>{successMessage}</span>
                                </div>
                            )}

                            {errorMessage && (
                                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-xs flex items-center gap-2">
                                    <svg className="w-4 h-4 text-red-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                    </svg>
                                    <span>{errorMessage}</span>
                                </div>
                            )}

                            {/* Submit Button */}
                            <div className="pt-2">
                                <button
                                    id="btn-submit-tour-booking"
                                    type="submit"
                                    className="w-full uppercase tracking-wider font-bold text-xs md:text-sm bg-[#9F2225] hover:bg-[#831c1e] text-white py-3 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 outline-none focus:ring-2 focus:ring-[#9F2225]/30 focus:ring-offset-2"
                                >
                                    Submit Booking Request
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </section>
    )
}

export default Custom_Banner